import { Base64 } from 'js-base64';

import { LocalStorageService } from './LocalStorage';
import AARPAuthService         from './AARPAuthService';

// TODO Change keys values to ark_
const SCORES_STORAGE_KEY = 'ark_scores';
const LAST_SCORE_STORAGE_KEY = 'ark_before-login-to-save-score';

type LocalScores = {
    [slug: string]: number;
};

type BeforeLoginToSaveScore = {
    slug: string;
    value: number;
};

const SendScoreAfterLoginKey = 'sendScoreAfterLogin';

class LocalScoreService {

    /**
     * If Login-To-Save was initiated, get last game score
     */
    getScoreIfLoginToSave(): BeforeLoginToSaveScore {
        const url = new URL((window as any).location.href);

        // Probably this is not user-friendly, while score are still easy to hack
        if (url.searchParams.get(SendScoreAfterLoginKey) === 'true') {

            let localLastScore = LocalStorageService.getItem(LAST_SCORE_STORAGE_KEY);
            if (localLastScore) {
                localLastScore = Base64.decode(localLastScore);
            }
            const lastGameScore = JSON.parse(localLastScore);

            LocalStorageService.removeItem(LAST_SCORE_STORAGE_KEY);

            lastGameScore.value = lastGameScore.value;
            return lastGameScore;
        }
    }

    /**
     * Save last game score separately from rest local scores and redirect
     */
    initLoginToSaveScore(score: BeforeLoginToSaveScore) {
        // Save game and score result before user clicked 'login to save score'
        LocalStorageService.setItem(LAST_SCORE_STORAGE_KEY,  Base64.encode(JSON.stringify(score)));
        this.redirectToLogin();
    }
    

    redirectToLogin() {
        const returnUrl = new URL(window.location.href);
        returnUrl.searchParams.set(SendScoreAfterLoginKey, 'true');

        const url = AARPAuthService.buildBaseLoginLink(returnUrl.href);

        window.location.replace(url.href);  
    }

    /**
     * Put score for game if it is higher or didn't exist before
     */
    saveScore(slug, value) {
        const scores = this.getScores();
        const previousScore = scores[slug] ? scores[slug] : 0; // 0 if there were no score for this game before

        if (value > previousScore) {
            scores[slug] = value;

            LocalStorageService.setItem(SCORES_STORAGE_KEY, Base64.encode(JSON.stringify(scores)));
        }
    }

    getScores(): LocalScores {
        let localScoresValue = LocalStorageService.getItem(SCORES_STORAGE_KEY);
        if (localScoresValue) {
            localScoresValue = Base64.decode(localScoresValue);
        }
        return JSON.parse(localScoresValue) || {};
    }

    getScoresAsArray(): Array<{slug, value}> {
        const scores = this.getScores();
        const slugs = Object.keys(scores);

        if (!slugs.length) {
            return [];
        }

        return slugs.map(slug => ({ slug, value: scores[slug] }));
    }

    clearLocalScores() {
        LocalStorageService.removeItem(SCORES_STORAGE_KEY);
    }
}

export default new LocalScoreService();
